import request from '@/utils/request'

const user_corporationApi = {
  user_corporation_list: '/user_corporation/',
  user_corporation_create: '/user_corporation/',
  user_corporation_update: '/user_corporation/',
  user_corporation_delete: '/user_corporation/'
}

/**
 * 列表
 */
export function user_corporation_list (parameter) {
  return request({
    url: user_corporationApi.user_corporation_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function user_corporation_create (parameter) {
  return request({
    url: user_corporationApi.user_corporation_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function user_corporation_update (parameter, user_corporation_id) {
  return request({
    url: user_corporationApi.user_corporation_update + user_corporation_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function user_corporation_delete (parameter) {
  return request({
    url: user_corporationApi.user_corporation_delete,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
